import styled from 'styled-components';
import { spacing } from 'theme';

export const StyledCards = styled.div`
  margin-top: ${spacing('xl')};
`;
